var _defs, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45mm",
    height: "45mm",
    viewBox: "0 0 127.5591 127.5591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f{fill:none;}.b{fill:#54ef9a;}.c{fill:#009b88;}.d{opacity:0.8;fill:url(#a);}.e{stroke:#004743;stroke-width:12px;}.e,.f{stroke-miterlimit:10;}.f{stroke:#54ef9a;stroke-width:8px;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-70.9964 272.6487)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,111.976a5.218,5.218,0,1,1,5.2178-5.2183A5.224,5.224,0,0,1,107.762,111.976Zm0-9.936a4.718,4.718,0,1,0,4.7178,4.7177A4.7229,4.7229,0,0,0,107.762,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,111.976a5.218,5.218,0,1,1,5.2177-5.2183A5.224,5.224,0,0,1,107.7622,111.976Zm0-9.936a4.718,4.718,0,1,0,4.7177,4.7177A4.7229,4.7229,0,0,0,107.7622,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0092,111.976a5.218,5.218,0,0,1,0-10.436,5.218,5.218,0,0,1,0,10.436Zm0-9.936a4.718,4.718,0,0,0,0,9.436,4.718,4.718,0,0,0,0-9.436Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,109.9858a4.2278,4.2278,0,1,1,4.2275-4.2281A4.2327,4.2327,0,0,1,22.7583,109.9858Zm0-8.2056a3.9778,3.9778,0,1,0,3.9775,3.9775A3.9828,3.9828,0,0,0,22.7583,101.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: 105.758,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5258,111.6025a4.845,4.845,0,1,1,4.3467-2.69A4.8219,4.8219,0,0,1,85.5258,111.6025Zm-1.9238-.9532a4.3444,4.3444,0,1,0-2.1865-2.5063A4.351,4.351,0,0,0,83.602,110.6493Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: 105.2849,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0471,
    cy: 107.1403,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,111.65a4.0261,4.0261,0,1,1,4.0264-4.0259A4.0311,4.0311,0,0,1,67.9321,111.65Zm0-7.8022a3.7761,3.7761,0,1,0,3.7764,3.7763A3.7807,3.7807,0,0,0,67.9321,103.8481Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6772,
    cy: 106.758,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0094,111.976a5.218,5.218,0,0,1,0-10.436,5.218,5.218,0,0,1,0,10.436Zm0-9.936a4.718,4.718,0,0,0,0,9.436,4.718,4.718,0,0,0,0-9.436Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,5.2232A5.2239,5.2239,0,0,1,102.5442.005a5.2178,5.2178,0,0,1,10.4356,0A5.224,5.224,0,0,1,107.762,5.2232Zm0-9.936A4.7229,4.7229,0,0,0,103.0442.005a4.7233,4.7233,0,0,0,4.7178,4.7182A4.7234,4.7234,0,0,0,112.48.005,4.723,4.723,0,0,0,107.762-4.7128Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,111.9757a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2238,5.2238,0,0,1,107.762,111.9757Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,107.762,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7434,91.7252a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2238,5.2238,0,0,1,105.7434,91.7252Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,105.7434,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.3255,91.3033a5.5469,5.5469,0,1,1,5.5478-5.5469A5.5531,5.5531,0,0,1,107.3255,91.3033Zm0-10.8437a5.2969,5.2969,0,1,0,5.2978,5.2968A5.3026,5.3026,0,0,0,107.3255,80.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.5716,70.17a5.0777,5.0777,0,1,1,5.0771-5.0776A5.0839,5.0839,0,0,1,107.5716,70.17Zm0-9.9053a4.8277,4.8277,0,1,0,4.8271,4.8277A4.8334,4.8334,0,0,0,107.5716,60.2647Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7552,43.3434a4.12,4.12,0,0,1-1.835-.4312h0a4.1418,4.1418,0,1,1,1.835.4312Zm-1.6124-.8794a3.64,3.64,0,1,0-1.6416-4.8789,3.6432,3.6432,0,0,0,1.6416,4.8789Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 108.3498,
    cy: 18.684,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7618,
    cy: 64.0924,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.4415,
    cy: 39.204,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7618,
    cy: 86.5073,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.8889,
    cy: 9.051,
    r: 2.3082
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,13.5885a5.0931,5.0931,0,1,1,5.0927-5.0933A5.0985,5.0985,0,0,1,11.5454,13.5885Zm0-9.9361a4.8431,4.8431,0,1,0,4.8427,4.8428A4.8485,4.8485,0,0,0,11.5454,3.6524Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.1342,36.9312a5.6147,5.6147,0,1,1,5.6143-5.6147A5.6206,5.6206,0,0,1,56.1342,36.9312Zm0-10.9794a5.3647,5.3647,0,1,0,5.3643,5.3647A5.37,5.37,0,0,0,56.1342,25.9518Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.9624,34.9083A5.2178,5.2178,0,1,1,60.18,29.6905,5.2238,5.2238,0,0,1,54.9624,34.9083Zm0-9.9356A4.7178,4.7178,0,1,0,59.68,29.6905,4.723,4.723,0,0,0,54.9624,24.9727Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.3979,24.96a4.5062,4.5062,0,1,1,4.5068-4.5064A4.5113,4.5113,0,0,1,65.3979,24.96Zm0-8.5123a4.0062,4.0062,0,1,0,4.0068,4.0059A4.01,4.01,0,0,0,65.3979,16.4478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.8315,79.7989a5.2676,5.2676,0,1,1,5.2676-5.2676A5.2736,5.2736,0,0,1,12.8315,79.7989Zm0-10.0351a4.7676,4.7676,0,1,0,4.7676,4.7675A4.7729,4.7729,0,0,0,12.8315,69.7638Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0581,24.8536a4.5061,4.5061,0,1,1,4.5058-4.5063A4.5113,4.5113,0,0,1,44.0581,24.8536Zm0-8.5122a4.0061,4.0061,0,1,0,4.0058,4.0059A4.01,4.01,0,0,0,44.0581,16.3414Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.8217,33.6676a4.5061,4.5061,0,1,1,4.5069-4.5059A4.5112,4.5112,0,0,1,10.8217,33.6676Zm0-8.5122a4.0061,4.0061,0,1,0,4.0069,4.0063A4.0105,4.0105,0,0,0,10.8217,25.1554Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.353,79.0377A4.5064,4.5064,0,1,1,59.86,74.5313,4.5113,4.5113,0,0,1,55.353,79.0377Zm0-8.5127A4.0064,4.0064,0,1,0,59.36,74.5313,4.0107,4.0107,0,0,0,55.353,70.525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.5083,47.3316a6.2854,6.2854,0,1,1,6.2851-6.2851A6.2929,6.2929,0,0,1,21.5083,47.3316Zm0-12.0708a5.7854,5.7854,0,1,0,5.7851,5.7857A5.7924,5.7924,0,0,0,21.5083,35.2608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.7075,100.5157a4.7988,4.7988,0,1,1,4.7988-4.7988A4.8041,4.8041,0,0,1,74.7075,100.5157Zm0-9.0976a4.2988,4.2988,0,1,0,4.2988,4.2988A4.3038,4.3038,0,0,0,74.7075,91.4181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,111.9757a5.2178,5.2178,0,1,1,5.2177-5.2178A5.2238,5.2238,0,0,1,107.7622,111.9757Zm0-9.9356a4.7178,4.7178,0,1,0,4.7177,4.7178A4.7229,4.7229,0,0,0,107.7622,102.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.1323,79.1671a5.0928,5.0928,0,1,1,5.0937-5.0928A5.0983,5.0983,0,0,1,74.1323,79.1671Zm0-9.9356a4.8428,4.8428,0,1,0,4.8437,4.8428A4.8485,4.8485,0,0,0,74.1323,69.2315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.5532,79.1969a4.86,4.86,0,1,1,4.8594-4.8594A4.8655,4.8655,0,0,1,75.5532,79.1969Zm0-9.2193a4.36,4.36,0,1,0,4.3594,4.36A4.3653,4.3653,0,0,0,75.5532,69.9776Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.1967,90.523a4.0261,4.0261,0,1,1,4.0264-4.0263A4.0311,4.0311,0,0,1,23.1967,90.523Zm0-7.8022a3.7761,3.7761,0,1,0,3.7764,3.7759A3.7805,3.7805,0,0,0,23.1967,82.7208Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.4614,100.3639a4.0264,4.0264,0,1,1,4.0263-4.0264A4.0312,4.0312,0,0,1,96.4614,100.3639Zm0-7.8028a3.7764,3.7764,0,1,0,3.7763,3.7764A3.7807,3.7807,0,0,0,96.4614,92.5611Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.1352,89.5211A4.1512,4.1512,0,1,1,28.2866,85.37,4.156,4.156,0,0,1,24.1352,89.5211Zm0-7.8023A3.6512,3.6512,0,1,0,27.7866,85.37,3.6555,3.6555,0,0,0,24.1352,81.7188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7436,91.7252a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2239,5.2239,0,0,1,105.7436,91.7252Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.723,4.723,0,0,0,105.7436,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.3256,91.3033a5.5469,5.5469,0,1,1,5.5469-5.5469A5.5531,5.5531,0,0,1,107.3256,91.3033Zm0-10.8437a5.2969,5.2969,0,1,0,5.2969,5.2968A5.3025,5.3025,0,0,0,107.3256,80.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.3532,
    cy: 8.4043,
    r: 2.3082
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.9838,14.1427a5.0916,5.0916,0,1,1,5.0918-5.0918A5.0976,5.0976,0,0,1,55.9838,14.1427Zm0-9.9331a4.8416,4.8416,0,1,0,4.8418,4.8413A4.847,4.847,0,0,0,55.9838,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.0786,57.8341A5.0916,5.0916,0,1,1,81.17,52.7428,5.0975,5.0975,0,0,1,76.0786,57.8341Zm0-9.9331A4.8416,4.8416,0,1,0,80.92,52.7428,4.847,4.847,0,0,0,76.0786,47.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.6938,56.4176a4.5689,4.5689,0,1,1,4.5684-4.5689A4.5744,4.5744,0,0,1,98.6938,56.4176Zm0-8.8877a4.3189,4.3189,0,1,0,4.3184,4.3188A4.3239,4.3239,0,0,0,98.6938,47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.6655,56.5221a5.2027,5.2027,0,1,1,5.2021-5.2027A5.2087,5.2087,0,0,1,100.6655,56.5221Zm0-9.9053a4.7027,4.7027,0,1,0,4.7021,4.7026A4.7077,4.7077,0,0,0,100.6655,46.6168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.5708,70.295a5.2027,5.2027,0,1,1,5.2031-5.2026A5.2086,5.2086,0,0,1,107.5708,70.295Zm0-9.9053a4.7027,4.7027,0,1,0,4.7031,4.7027A4.7076,4.7076,0,0,0,107.5708,60.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.0776,47.2091A5.2027,5.2027,0,1,1,69.28,42.0064,5.2088,5.2088,0,0,1,64.0776,47.2091Zm0-9.9053A4.7027,4.7027,0,1,0,68.78,42.0064,4.7077,4.7077,0,0,0,64.0776,37.3038Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.4614,12.7574A4.7778,4.7778,0,1,1,101.24,7.98,4.7834,4.7834,0,0,1,96.4614,12.7574Zm0-9.0556A4.2778,4.2778,0,1,0,100.74,7.98,4.2825,4.2825,0,0,0,96.4614,3.7018Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.19,58.631a5.6756,5.6756,0,1,1,5.6758-5.6758A5.6822,5.6822,0,0,1,33.19,58.631Zm0-11.1011a5.4256,5.4256,0,1,0,5.4258,5.4253A5.4313,5.4313,0,0,0,33.19,47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.6342,25.3209a6.0081,6.0081,0,1,1,6.0088-6.0078A6.0149,6.0149,0,0,1,86.6342,25.3209Zm0-11.7661a5.7581,5.7581,0,1,0,5.7588,5.7583A5.7645,5.7645,0,0,0,86.6342,13.5548Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.1938,103.4181a5.7986,5.7986,0,1,1,5.7979-5.7989A5.8057,5.8057,0,0,1,56.1938,103.4181Zm0-11.3472a5.5486,5.5486,0,1,0,5.5479,5.5483A5.5547,5.5547,0,0,0,56.1938,92.0709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5336,89.7769a4.8318,4.8318,0,1,1,4.8321-4.8315A4.8375,4.8375,0,0,1,85.5336,89.7769Zm0-9.4135a4.5818,4.5818,0,1,0,4.5821,4.582A4.5874,4.5874,0,0,0,85.5336,80.3634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,57.5743a4.8318,4.8318,0,1,1,4.832-4.8315A4.8375,4.8375,0,0,1,11.5454,57.5743Zm0-9.4136a4.5818,4.5818,0,1,0,4.582,4.5821A4.5875,4.5875,0,0,0,11.5454,48.1607Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.896,100.8141a4.2281,4.2281,0,1,1,4.2285-4.2281A4.2325,4.2325,0,0,1,32.896,100.8141Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.978A3.9823,3.9823,0,0,0,32.896,92.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0581,46.4835a4.2281,4.2281,0,1,1,4.2285-4.228A4.2325,4.2325,0,0,1,44.0581,46.4835Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.9781A3.9823,3.9823,0,0,0,44.0581,38.2774Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.0786,37.0885A4.2281,4.2281,0,1,1,80.3071,32.86,4.2325,4.2325,0,0,1,76.0786,37.0885Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.978A3.9823,3.9823,0,0,0,76.0786,28.8824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.809,98.8062a4.228,4.228,0,1,1,4.2276-4.228A4.2324,4.2324,0,0,1,75.809,98.8062Zm0-8.206a3.978,3.978,0,1,0,3.9776,3.978A3.9823,3.9823,0,0,0,75.809,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.8764,67.8536a4.228,4.228,0,1,1,4.2276-4.228A4.2325,4.2325,0,0,1,85.8764,67.8536Zm0-8.206a3.978,3.978,0,1,0,3.9776,3.978A3.9822,3.9822,0,0,0,85.8764,59.6476Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.7045,
    cy: 7.8339,
    r: 1.8078
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.3276,11.6373a4.128,4.128,0,0,1-1.8379-.4341h0a4.1125,4.1125,0,1,1,1.8379.4341Zm.01-7.7813a3.6392,3.6392,0,0,0-1.625,6.899h0a3.6393,3.6393,0,1,0,1.625-6.899Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.9907,67.7647a4.1192,4.1192,0,0,1-1.834-.4311h0a4.1421,4.1421,0,1,1,1.834.4311ZM65,59.984a3.64,3.64,0,0,0-1.6211,6.9013h0A3.64,3.64,0,1,0,65,59.984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7573,43.3458a4.1261,4.1261,0,0,1-1.8369-.4336h0a4.115,4.115,0,1,1,1.8369.4336Zm-1.6143-.8818a3.64,3.64,0,1,0-1.6416-4.8789,3.6238,3.6238,0,0,0,1.6416,4.8789Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.228,33.8326a4.1308,4.1308,0,0,1-1.8379-.4341h0a4.1125,4.1125,0,1,1,1.8379.4341ZM95.6127,32.95a3.64,3.64,0,1,0-1.6416-4.8784A3.6452,3.6452,0,0,0,95.6127,32.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.7006,78.6734a4.1315,4.1315,0,0,1-1.8379-.4341h0a4.1135,4.1135,0,1,1,1.8379.4341Zm-1.6152-.8823a3.64,3.64,0,1,0-1.6416-4.8784,3.6081,3.6081,0,0,0,1.6416,4.8784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.8432,23.12a5.2178,5.2178,0,1,1,4.6817-2.897A5.1857,5.1857,0,0,1,24.8432,23.12Zm.0127-9.938a4.7232,4.7232,0,1,0,2.0938.4951A4.7307,4.7307,0,0,0,24.8559,13.1817Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0532,89.4366a5.23,5.23,0,1,1,1.6689-.2749A5.2,5.2,0,0,1,44.0532,89.4366Zm.0088-9.9409A4.719,4.719,0,0,0,41.96,88.4415h0a4.7176,4.7176,0,1,0,2.1016-8.9458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.96,68.1339a4.5166,4.5166,0,1,1,1.4414-.2373A4.49,4.49,0,0,1,43.96,68.1339Zm.0117-8.5137a4.0053,4.0053,0,1,0,1.7744.4175A4.0121,4.0121,0,0,0,43.9721,59.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 97.0033,
    cy: 8.4954,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0471,
    cy: 107.274,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.3436,
    cy: 20.1858,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,5.2232A5.2239,5.2239,0,0,1,102.5444.005a5.2178,5.2178,0,1,1,10.4355,0A5.2239,5.2239,0,0,1,107.7622,5.2232Zm0-9.936A4.7229,4.7229,0,0,0,103.0444.005a4.7233,4.7233,0,0,0,4.7178,4.7182A4.7233,4.7233,0,0,0,112.48.005,4.7229,4.7229,0,0,0,107.7622-4.7128Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0092,5.2232A5.2239,5.2239,0,0,1-4.2085.005,5.2238,5.2238,0,0,1,1.0092-5.2128,5.2238,5.2238,0,0,1,6.227.005,5.2239,5.2239,0,0,1,1.0092,5.2232Zm0-9.936A4.7229,4.7229,0,0,0-3.7085.005,4.7233,4.7233,0,0,0,1.0092,4.7232,4.7233,4.7233,0,0,0,5.727.005,4.7229,4.7229,0,0,0,1.0092-4.7128Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0092,111.9757a5.2178,5.2178,0,0,1,0-10.4356,5.2178,5.2178,0,0,1,0,10.4356Zm0-9.9356a4.7178,4.7178,0,0,0,0,9.4356,4.7178,4.7178,0,0,0,0-9.4356Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 66.0623,
    cy: 20.4539,
    r: 1.9848
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 43.9649,
    cy: 20.0903,
    r: 1.7241
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 34.7013,
    cy: 31.3948,
    r: 2.8992
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.5454,
    cy: 29.4764,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 25.0329,
    cy: 17.6064,
    r: 2.4453
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 54.9324,
    cy: 31.3166,
    r: 2.1549
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.7074,
    cy: 32.8602,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,109.9859a4.228,4.228,0,1,1,4.2275-4.228A4.2327,4.2327,0,0,1,22.7583,109.9859Zm0-8.206a3.978,3.978,0,1,0,3.9775,3.978A3.9831,3.9831,0,0,0,22.7583,101.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: 105.758,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,3.233A4.2327,4.2327,0,0,1,18.53-.995a4.2326,4.2326,0,0,1,4.2286-4.2276A4.2324,4.2324,0,0,1,26.9858-.995,4.2325,4.2325,0,0,1,22.7583,3.233Zm0-8.2056A3.9828,3.9828,0,0,0,18.78-.995a3.9832,3.9832,0,0,0,3.9786,3.978A3.9823,3.9823,0,0,0,26.7358-.995,3.9819,3.9819,0,0,0,22.7583-4.9726Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: -0.9948,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.8816,
    cy: 29.8602,
    r: 1.8753
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.6346,
    cy: 42.1997,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 108.3498,
    cy: 18.684,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 65.1199,
    cy: 42.1997,
    r: 2.418
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.0582,
    cy: 42.2555,
    r: 2.8269
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.7578,
    cy: 42.0062,
    r: 1.8159
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.1336,
    cy: 52.7142,
    r: 2.0095
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.7052,
    cy: 53.5636,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7618,
    cy: 64.0924,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.2704,
    cy: 52.5544,
    r: 2.3023
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.7074,
    cy: 51.9554,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 98.2318,
    cy: 51.3974,
    r: 1.3452
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.8764,
    cy: 63.6256,
    r: 2.4114
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.7319,
    cy: 64.1525,
    r: 2.2005
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.0046,
    cy: 62.1525,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5258,4.85a4.8219,4.8219,0,0,1-2.1465-.5049A4.813,4.813,0,0,1,80.9418,1.55a4.8092,4.8092,0,0,1,.253-3.7,4.8526,4.8526,0,0,1,6.4941-2.1846A4.8507,4.8507,0,0,1,89.8725,2.16,4.8515,4.8515,0,0,1,85.5258,4.85ZM83.602,3.8966a4.3511,4.3511,0,0,0,5.8232-1.959,4.35,4.35,0,0,0-1.9589-5.8237A4.3505,4.3505,0,0,0,81.642-1.9272,4.318,4.318,0,0,0,81.4155,1.39,4.316,4.316,0,0,0,83.602,3.8966Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: -1.4679,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.53,111.6051a4.8276,4.8276,0,0,1-2.15-.5078h0a4.8142,4.8142,0,1,1,2.15.5078Zm.0118-9.1914a4.3439,4.3439,0,0,0-1.9395,8.2353h0a4.3444,4.3444,0,1,0,1.9395-8.2353Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: 105.2849,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.1169,
    cy: 63.7455,
    r: 2.0314
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.9812,
    cy: 74.842,
    r: 2.1619
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.1898,
    cy: 74.842,
    r: 1.9965
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.7323,
    cy: 74.0742,
    r: 1.7475
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.1294,
    cy: 74.5314,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.4415,
    cy: 39.204,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.6436,
    cy: 74.842,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7618,
    cy: 86.5073,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.0093,91.7252a5.2238,5.2238,0,0,1-5.2178-5.2178A5.2239,5.2239,0,0,1-1.0093,81.29a5.224,5.224,0,0,1,5.2178,5.2178A5.2239,5.2239,0,0,1-1.0093,91.7252Zm0-9.9356a4.723,4.723,0,0,0-4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178,4.7178,4.723,4.723,0,0,0,4.7178-4.7178A4.723,4.723,0,0,0-1.0093,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5727,91.3033a5.5469,5.5469,0,1,1,0-11.0937,5.5469,5.5469,0,1,1,0,11.0937Zm0-10.8437a5.2969,5.2969,0,1,0,0,10.5937,5.2969,5.2969,0,1,0,0-10.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.8188,70.17a5.0777,5.0777,0,1,1,0-10.1553,5.0777,5.0777,0,0,1,0,10.1553Zm0-9.9053a4.8277,4.8277,0,1,0,0,9.6553,4.8277,4.8277,0,0,0,0-9.6553Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0024,43.3434a4.1206,4.1206,0,0,1-1.835-.4312h0a4.1463,4.1463,0,0,1-1.8662-5.55A4.1437,4.1437,0,0,1,1.85,35.4962a4.114,4.114,0,0,1,2.083,2.3877,4.1126,4.1126,0,0,1-.2168,3.1616A4.144,4.144,0,0,1,.0024,43.3434ZM-1.61,42.464A3.643,3.643,0,0,0,3.269,40.8228a3.6168,3.6168,0,0,0,.19-2.7793,3.6174,3.6174,0,0,0-1.832-2.0991,3.6423,3.6423,0,0,0-4.8789,1.6407A3.6457,3.6457,0,0,0-1.61,42.464Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.5971,
    cy: 18.684,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 64.0924,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6887,
    cy: 39.204,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 86.5073,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.363,
    cy: 85.512,
    r: 1.523
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 74.9798,
    cy: 11.631,
    r: 1.523
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,111.7843a4.0264,4.0264,0,1,1,4.0264-4.0264A4.0312,4.0312,0,0,1,67.9321,111.7843Zm0-7.8028a3.7764,3.7764,0,1,0,3.7764,3.7764A3.7808,3.7808,0,0,0,67.9321,103.9815Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.7319,
    cy: 85.413,
    r: 1.8349
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 43.9649,
    cy: 85.413,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0471,
    cy: 0.3875,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,4.8976A4.0311,4.0311,0,0,1,63.9057.8717a4.0264,4.0264,0,1,1,8.0528,0A4.0311,4.0311,0,0,1,67.9321,4.8976Zm0-7.8023A3.7808,3.7808,0,0,0,64.1557.8717a3.7764,3.7764,0,0,0,7.5528,0A3.7808,3.7808,0,0,0,67.9321-2.9047Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6772,
    cy: 0.0052,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.1898,
    cy: 96.2563,
    r: 1.5727
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 23.2637,
    cy: 86.1318,
    r: 1.9158
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.8221,
    cy: 96.6908,
    r: 2.0096
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 54.9333,
    cy: 96.3376,
    r: 2.5465
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.0787,
    cy: 95.5861,
    r: 1.5598
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.6436,
    cy: 96.3376,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.27,49.74a.25.25,0,0,1-.25-.25V44.6178a.25.25,0,0,1,.5,0V49.49A.25.25,0,0,1,55.27,49.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.0874,50.1344a.25.25,0,0,1-.212-.3833l1.33-2.1084a.25.25,0,0,1,.4238.2666l-1.33,2.1084A.25.25,0,0,1,57.0874,50.1344Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.2124,51.3634a.1249.1249,0,0,1-.0372-.2442l5.6192-1.7719a.1283.1283,0,0,1,.1562.0815.1247.1247,0,0,1-.082.1567L58.25,51.3575A.1186.1186,0,0,1,58.2124,51.3634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.392,53.9146a.257.257,0,0,1-.0332-.0019l-4.0566-.5391a.2507.2507,0,0,1-.2148-.2807.2433.2433,0,0,1,.2812-.2154l4.0566.5391a.25.25,0,0,1-.0332.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.5727,60.7516a.1246.1246,0,0,1-.12-.0918l-1.4385-5.2447a.1246.1246,0,1,1,.24-.0664l1.4385,5.2447a.1248.1248,0,0,1-.0869.1538A.13.13,0,0,1,57.5727,60.7516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.9956,56.8629a.2484.2484,0,0,1-.1866-.084l-1.4228-1.6a.25.25,0,1,1,.373-.332l1.4229,1.6a.25.25,0,0,1-.1865.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.9868,59.0885a.2725.2725,0,0,1-.044-.0039.25.25,0,0,1-.2021-.29l.5849-3.2925a.25.25,0,0,1,.4922.0879l-.5849,3.2925A.25.25,0,0,1,53.9868,59.0885Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.5249,56.1226a.1234.1234,0,0,1-.0909-.0395.1251.1251,0,0,1,.0049-.1768l1.4434-1.354a.1254.1254,0,0,1,.1719.1827l-1.4434,1.354A.1277.1277,0,0,1,51.5249,56.1226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.4321,53.5626a.125.125,0,0,1-.0166-.249l4.6709-.6314a.1252.1252,0,0,1,.0332.2481l-4.6709.6313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.2465,50.9957a.2483.2483,0,0,1-.1308-.0371l-2.0352-1.2554a.25.25,0,1,1,.2617-.4258l2.0352,1.2554a.25.25,0,0,1-.1309.4629Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.5766,49.8863a.1241.1241,0,0,1-.1133-.0727l-1.5595-3.4029a.1247.1247,0,1,1,.2265-.1045l1.56,3.4029a.1242.1242,0,0,1-.0615.166A.1209.1209,0,0,1,53.5766,49.8863Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.5512,31.3785l-.0263-.0015-7.1475-.7627a.25.25,0,1,1,.0527-.497l7.1475.7627a.25.25,0,0,1-.0264.4985Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.52,28.9649a.25.25,0,0,1-.14-.0424l-3.3984-2.2876a.25.25,0,0,1,.2793-.4151L31.66,28.5074a.25.25,0,0,1-.14.4575Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.5835,27.9268a.1253.1253,0,0,1-.1231-.104L32.227,20.6173a.125.125,0,0,1,.1016-.1441.12.12,0,0,1,.1445.1021l1.2334,7.2056a.1249.1249,0,0,1-.1016.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.1645,28.273a.25.25,0,0,1-.2412-.3173l1.3477-4.82a.25.25,0,0,1,.4824.1348l-1.3477,4.82A.2509.2509,0,0,1,36.1645,28.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.2085,29.7413a.125.125,0,0,1-.0381-.2441L42.94,27.96a.127.127,0,0,1,.1572.0805.1248.1248,0,0,1-.081.1577l-4.77,1.5376A.1291.1291,0,0,1,38.2085,29.7413Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.6889,34.3956a.2426.2426,0,0,1-.0527-.0059l-7.3985-1.6079a.2493.2493,0,0,1-.1914-.2973.2521.2521,0,0,1,.2969-.191l7.3985,1.608a.25.25,0,0,1-.0528.4941Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.2661,37.5694a.2478.2478,0,0,1-.211-.1162l-1.917-3.0283a.25.25,0,1,1,.4219-.2676l1.917,3.0283a.25.25,0,0,1-.0771.3453A.2545.2545,0,0,1,39.2661,37.5694Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.6713,40.8546a.1248.1248,0,0,1-.123-.105l-.8594-5.36a.1246.1246,0,0,1,.1035-.1435.1283.1283,0,0,1,.1426.1035l.8594,5.36a.1246.1246,0,0,1-.1035.1435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.561,40.985a.25.25,0,0,1-.2334-.3384L32.4907,34.92a.25.25,0,1,1,.4668.1768l-2.1631,5.7265A.2491.2491,0,0,1,30.561,40.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.7915,34.8268a.125.125,0,0,1-.0586-.2354l2.0879-1.1128a.1249.1249,0,0,1,.1171.2207L28.85,34.8121A.1269.1269,0,0,1,28.7915,34.8268Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.5473,39.9137a.1248.1248,0,0,1-.0947-.2066l3.1152-3.6137a.125.125,0,1,1,.1895.163L88.642,39.87A.1237.1237,0,0,1,88.5473,39.9137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.1323,41.464a.25.25,0,0,1-.0293-.4986l2.8613-.3354a.259.259,0,0,1,.2774.2192.25.25,0,0,1-.2188.2778l-2.8613.3355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.8989,43.9439l-.0166-.0009-5.12-.6841a.1258.1258,0,0,1-.1075-.1406.124.124,0,0,1,.1407-.1075l5.12.6841a.125.125,0,0,1-.0166.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.6489,46.2618a.1257.1257,0,0,1-.084-.0322L88.66,44.5186a.1251.1251,0,0,1,.168-.1855l1.9053,1.7109a.1252.1252,0,0,1-.084.2178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.3588,51.2042a.25.25,0,0,1-.2451-.1992l-1.1406-5.5166a.2508.2508,0,0,1,.1943-.2954.2457.2457,0,0,1,.2959.1938l1.1407,5.5166a.2508.2508,0,0,1-.1944.2954A.2312.2312,0,0,1,88.3588,51.2042Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.6674,46.88a.25.25,0,0,1-.1689-.4346L84.17,44.004a.25.25,0,0,1,.3379.3691l-2.6719,2.4414A.2485.2485,0,0,1,81.6674,46.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.0854,44.2989a.25.25,0,0,1-.042-.4966l6.6006-1.1362a.25.25,0,0,1,.084.4932l-6.6006,1.1362A.2479.2479,0,0,1,77.0854,44.2989Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.2768,41.2188l-.0254-.0024L78.95,40.3316a.1244.1244,0,0,1-.0967-.1479A.1223.1223,0,0,1,79,40.0865l4.3018.8848a.1251.1251,0,0,1-.0254.2475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.7631,39.89a.1239.1239,0,0,1-.0976-.0468L81.851,36.3141a.1251.1251,0,0,1,.1953-.1563l2.8145,3.5293a.1249.1249,0,0,1-.0977.2031Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.6342,38.627a.25.25,0,0,1-.25-.25V32.2223a.25.25,0,0,1,.5,0V38.377A.25.25,0,0,1,86.6342,38.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.9975,47.0841a.129.129,0,0,1-.042-.0073.1255.1255,0,0,1-.0762-.16l.5977-1.6778a.1254.1254,0,0,1,.2363.084l-.5976,1.6778A.1254.1254,0,0,1,84.9975,47.0841Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.4213,62.3863a.1213.1213,0,0,1-.0644-.018l-4.083-2.4693a.1249.1249,0,1,1,.1289-.2139l4.083,2.4693a.125.125,0,0,1,.043.1714A.1271.1271,0,0,1,19.4213,62.3863Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.562,60.711a.2508.2508,0,0,1-.24-.18l-.8066-2.7652a.25.25,0,1,1,.48-.14l.8066,2.7651a.2514.2514,0,0,1-.17.31A.2707.2707,0,0,1,20.562,60.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.5151,60.6143a.1246.1246,0,0,1-.125-.1206l-.1787-5.1621a.1257.1257,0,0,1,.1211-.1294.1218.1218,0,0,1,.1289.1206L22.64,60.485a.1257.1257,0,0,1-.1211.1293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.96,61.5455a.2537.2537,0,0,1-.1338-.0386.25.25,0,0,1-.0771-.3452l1.37-2.1641a.25.25,0,1,1,.4219.2676l-1.37,2.1641A.2475.2475,0,0,1,23.96,61.5455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.2124,62.756a.1251.1251,0,0,1-.045-.2417l5.2491-2.044a.125.125,0,0,1,.09.2334l-5.249,2.0439A.1324.1324,0,0,1,25.2124,62.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.3129,68.1554a.2484.2484,0,0,1-.1543-.0533l-2.8525-2.2285a.25.25,0,1,1,.3086-.3935l2.8525,2.2285a.25.25,0,0,1-.1543.4468Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.5307,73.1031a.25.25,0,0,1-.2363-.167l-2.22-6.3193a.25.25,0,0,1,.4726-.166l2.22,6.3193a.2513.2513,0,0,1-.1533.3189A.2484.2484,0,0,1,25.5307,73.1031Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.43,71.754h-.0049a.1256.1256,0,0,1-.12-.1294l.1553-4.3887a.1253.1253,0,0,1,.125-.1206H21.59a.1256.1256,0,0,1,.12.1294l-.1553,4.3887A.1253.1253,0,0,1,21.43,71.754Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.017,69.61a.25.25,0,0,1-.1865-.417L19.8422,65.83a.25.25,0,0,1,.3731.334l-3.0117,3.3628A.2527.2527,0,0,1,17.017,69.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.2788,65.5328a.1248.1248,0,0,1-.0205-.248l6.0683-1.0254a.1247.1247,0,1,1,.041.2461l-6.0683,1.0254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.0825,64.8165a.2225.2225,0,0,1-.043-.0039l-1.7539-.3091a.2491.2491,0,0,1-.2031-.29.246.246,0,0,1,.289-.2027l1.7539.3091a.25.25,0,0,1-.0429.4961Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.96,72.7755a.25.25,0,0,1-.14-.4575l2.9433-1.9756a.25.25,0,1,1,.2793.415L99.1,72.733A.2506.2506,0,0,1,98.96,72.7755Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.4868,71.7877a.2717.2717,0,0,1-.0586-.0068.2507.2507,0,0,1-.1846-.3018l1.4736-6.12a.2548.2548,0,0,1,.3018-.1846.2506.2506,0,0,1,.1846.3018l-1.4737,6.12A.25.25,0,0,1,97.4868,71.7877Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.3481,71.6627a.126.126,0,0,1-.1221-.0972l-.7773-3.3994a.1256.1256,0,0,1,.0937-.15.1241.1241,0,0,1,.15.0942l.7774,3.4a.1257.1257,0,0,1-.0938.15A.15.15,0,0,1,95.3481,71.6627Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.0073,72.6505a.126.126,0,0,1-.0889-.0371l-3.3633-3.419a.125.125,0,0,1,.1778-.1758l3.3632,3.419a.125.125,0,0,1-.0888.2129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.5229,74.5587a.2419.2419,0,0,1-.0322-.002l-3.2822-.42a.25.25,0,0,1-.2159-.28.2452.2452,0,0,1,.28-.2163l3.2822.42a.25.25,0,0,1-.0322.4981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.2876,77.5182a.125.125,0,0,1-.0264-.2471l5.4111-1.1821a.1275.1275,0,0,1,.1485.0952.1254.1254,0,0,1-.0957.1489l-5.4112,1.1821A.1186.1186,0,0,1,88.2876,77.5182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.5512,79.546a.2469.2469,0,0,1-.1465-.0474.2505.2505,0,0,1-.0566-.3491l1.2861-1.7808a.25.25,0,0,1,.4063.293l-1.2862,1.7808A.2524.2524,0,0,1,93.5512,79.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.8862,83.7032l-.0088-.0005a.1246.1246,0,0,1-.1162-.1328l.3789-5.5742a.13.13,0,0,1,.1338-.1162.1247.1247,0,0,1,.1162.1328l-.3789,5.5742A.1257.1257,0,0,1,95.8862,83.7032Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M99.4418,79.72a.25.25,0,0,1-.2011-.1016l-1.2188-1.6494a.25.25,0,0,1,.0528-.35.2527.2527,0,0,1,.35.0528l1.2187,1.6494a.25.25,0,0,1-.2012.3984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.6186,77.7623a.1214.1214,0,0,1-.0547-.0127l-2.9326-1.4263a.1249.1249,0,0,1,.1094-.2246l2.9326,1.4263a.125.125,0,0,1-.0547.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.1137,74.4625a.1248.1248,0,0,1-.0176-.2485l6.1885-.8985a.121.121,0,0,1,.1416.1055.1255.1255,0,0,1-.1064.1416l-6.1885.8984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.0307,82.6466a.25.25,0,0,1-.2441-.1973L62.6528,77.211a.25.25,0,0,1,.4883-.1054l1.1338,5.2382a.25.25,0,0,1-.1914.2969A.2435.2435,0,0,1,64.0307,82.6466Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.7368,82.7833a.2466.2466,0,0,1-.1075-.0244.2492.2492,0,0,1-.1181-.333l.83-1.7422a.252.252,0,0,1,.333-.1182.2492.2492,0,0,1,.1181.333l-.83,1.7422A.2507.2507,0,0,1,65.7368,82.7833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.9321,84.1139a.1252.1252,0,0,1-.0537-.2383l3.5293-1.6612a.1254.1254,0,0,1,.1074.2266l-3.5293,1.6611A.132.132,0,0,1,66.9321,84.1139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.2426,86.3443l-.0146-.0005-5.6572-.3378a.2511.2511,0,0,1-.2354-.2647.2415.2415,0,0,1,.2647-.2344l5.6572.3379a.25.25,0,0,1-.0147.4995Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.27,89.5841a.249.249,0,0,1-.208-.1118l-1.1182-1.6885a.25.25,0,1,1,.416-.2764l1.1182,1.6885a.25.25,0,0,1-.208.3882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63.4643,92.0709l-.0176-.0015a.1247.1247,0,0,1-.1064-.1411l.5664-4.0024a.1217.1217,0,0,1,.1416-.106.1246.1246,0,0,1,.1064.1411l-.5664,4.0025A.1251.1251,0,0,1,63.4643,92.0709Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.9155,87.8956a.25.25,0,0,1-.126-.4658l1.9512-1.1382a.25.25,0,1,1,.2519.4316l-1.9511,1.1382A.2467.2467,0,0,1,59.9155,87.8956Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.8667,85.07l-.0088-.0005-5.8828-.4258a.1248.1248,0,0,1-.1163-.1333.1284.1284,0,0,1,.1338-.1157l5.8828.4258a.1249.1249,0,0,1-.0087.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.5317,83.2833a.1244.1244,0,0,1-.085-.0332l-1.4248-1.3145a.1251.1251,0,0,1,.17-.1836l1.4249,1.3145a.125.125,0,0,1-.085.2168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.9985,3.8175a.121.121,0,0,1-.0586-.0147L47.4272,1.9513a.1249.1249,0,0,1,.1172-.2207l3.5127,1.8515a.1251.1251,0,0,1-.0586.2354Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.0629,5.2452a.2478.2478,0,0,1-.2275-.1475L45.92,3.0626a.25.25,0,1,1,.455-.2051l.9151,2.0352a.25.25,0,0,1-.125.3305A.2463.2463,0,0,1,47.0629,5.2452Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.0483,7.4264a.1457.1457,0,0,1-.0254-.0025.1245.1245,0,0,1-.0967-.1484L43.811,3.07a.1313.1313,0,0,1,.1475-.0967.1246.1246,0,0,1,.0966.1485L43.17,7.3272A.1249.1249,0,0,1,43.0483,7.4264Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.6127,4.6764a.1235.1235,0,0,1-.0761-.0259.1248.1248,0,0,1-.0225-.1758l1.6279-2.106a.123.123,0,0,1,.1748-.0224.1248.1248,0,0,1,.0225.1758L40.7114,4.628A.1242.1242,0,0,1,40.6127,4.6764Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.4106,2.46a.25.25,0,0,1-.1035-.4776L41.4477.5494a.25.25,0,1,1,.207.4551L38.5141,2.4371A.2492.2492,0,0,1,38.4106,2.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6772,
    cy: 106.758,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.7085,105.5216a.1208.1208,0,0,1-.0547-.0127l-4.0889-1.99a.1249.1249,0,0,1,.1094-.2246l4.0888,1.99a.1249.1249,0,0,1-.0546.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.0278,104.4513a.2494.2494,0,0,1-.2051-.1075l-1.6562-2.3818a.25.25,0,1,1,.41-.2852l1.6563,2.3819a.2494.2494,0,0,1-.0625.3476A.2466.2466,0,0,1,43.0278,104.4513Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.7319,103.8077l-.0274-.0015a.25.25,0,0,1-.2207-.2758l.669-6.0957a.2419.2419,0,0,1,.2754-.2212.25.25,0,0,1,.2207.2758l-.669,6.0958A.2493.2493,0,0,1,44.7319,103.8077Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.6879,104.6261a.1251.1251,0,0,1-.1025-.1963l2.4033-3.4683a.1249.1249,0,0,1,.2051.1426l-2.4033,3.4683A.125.125,0,0,1,46.6879,104.6261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.6167,9.0089l-.0225-.002a.1247.1247,0,0,1-.1006-.145l.8857-4.9062a.12.12,0,0,1,.1456-.1011.1247.1247,0,0,1,.1.145L75.74,8.9059A.125.125,0,0,1,75.6167,9.0089Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.352,10.0382a.25.25,0,0,1-.1572-.4444l2.3125-1.8715a.25.25,0,1,1,.3144.3886L77.5092,9.9825A.2467.2467,0,0,1,77.352,10.0382Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.4409,11.756H77.78a.125.125,0,0,1,0-.25h5.6612a.125.125,0,0,1,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78.3139,14.6183a.124.124,0,0,1-.0762-.0259l-1.39-1.0635A.125.125,0,1,1,77,13.3307l1.39,1.0634a.1251.1251,0,0,1,.0234.1753A.128.128,0,0,1,78.3139,14.6183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.1049,18.9342a.25.25,0,0,1-.247-.2139L75.18,14.0538a.25.25,0,1,1,.4942-.0723l.6777,4.6665a.2494.2494,0,0,1-.2109.2837A.3061.3061,0,0,1,76.1049,18.9342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.2905,16.2164a.1236.1236,0,0,1-.06-.0151.1255.1255,0,0,1-.05-.17l1.166-2.13a.1248.1248,0,1,1,.2188.12l-1.166,2.13A.1244.1244,0,0,1,72.2905,16.2164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.0473,14.2115a.25.25,0,0,1-.081-.4863l4.4785-1.5391a.25.25,0,0,1,.1621.4727l-4.4785,1.539A.2433.2433,0,0,1,68.0473,14.2115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.8335,10.8375a.1313.1313,0,0,1-.0333-.0044l-2.1787-.6045a.1251.1251,0,0,1,.0664-.2412l2.1788.6045a.1251.1251,0,0,1-.0332.2456Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.3374,9.5982a.25.25,0,0,1-.2207-.1328l-1.6241-3.06a.25.25,0,1,1,.4414-.2344l1.6241,3.06a.25.25,0,0,1-.1036.3379A.2442.2442,0,0,1,73.3374,9.5982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.7016,22.8663a.25.25,0,0,1-.1377-.459l3.3682-2.2182a.25.25,0,1,1,.2754.4179l-3.3682,2.2183A.2506.2506,0,0,1,102.7016,22.8663Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.1938,19.5631a.25.25,0,0,1-.0215-.499l7.44-.629a.2382.2382,0,0,1,.2706.2281.25.25,0,0,1-.2276.27l-7.44.6289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7856,17.2047a.1211.1211,0,0,1-.0547-.0127l-1.8164-.8819a.125.125,0,0,1-.0576-.1669.1265.1265,0,0,1,.167-.0577l1.8164.8819a.125.125,0,0,1-.0547.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7622,16.4478a.2485.2485,0,0,1-.2246-.1411l-1.5049-3.1128a.25.25,0,1,1,.4492-.2177l1.5049,3.1128a.249.249,0,0,1-.1162.3339A.2414.2414,0,0,1,106.7622,16.4478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5971,16.2545a.25.25,0,0,1-.25-.25V10.9806a.25.25,0,0,1,.5,0v5.0239A.25.25,0,0,1,1.5971,16.2545Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.2124,16.5108a.1226.1226,0,0,1-.0762-.0263.125.125,0,0,1-.0225-.1753l1.4737-1.8985a.1249.1249,0,0,1,.1972.1534L3.311,16.4625A.1243.1243,0,0,1,3.2124,16.5108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,17.87a.1264.1264,0,0,1-.1211-.0923.1251.1251,0,0,1,.0888-.1533l6.4375-1.74a.1282.1282,0,0,1,.1534.0879.1253.1253,0,0,1-.0889.1533l-6.4375,1.74A.12.12,0,0,1,3.9,17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,20.5758a.2782.2782,0,0,1-.0528-.0054l-3.9814-.8555a.25.25,0,0,1-.1914-.2973.2558.2558,0,0,1,.2969-.1919l3.9814.8554A.25.25,0,0,1,8,20.5758Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.7661,25.4459A.2478.2478,0,0,1,5.56,25.337L2.8383,21.3517a.25.25,0,1,1,.4121-.2823l2.7217,3.9854a.25.25,0,0,1-.206.3911Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.396,23.7491a.1253.1253,0,0,1-.1221-.1514l.5244-2.4331a.1249.1249,0,1,1,.2441.0528L.518,23.6505A.125.125,0,0,1,.396,23.7491Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8188,94.0411a.25.25,0,0,1-.2393-.1768l-.71-2.3159a.25.25,0,1,1,.4785-.1465l.71,2.316a.251.251,0,0,1-.1661.3125A.2539.2539,0,0,1,9.8188,94.0411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,93.9161l-.0215-.0019a.125.125,0,0,1-.1016-.1451l1.2862-7.2837a.1213.1213,0,0,1,.1445-.101.1248.1248,0,0,1,.1015.145l-1.2861,7.2837A.125.125,0,0,1,11.5454,93.9161Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.8315,94.4991a.1254.1254,0,0,1-.0879-.2143l2.4815-2.4283a.1253.1253,0,0,1,.1757.1787l-2.4814,2.4283A.1259.1259,0,0,1,12.8315,94.4991Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.6528,96.5064a.25.25,0,0,1-.0342-.4975l6.2686-.8584a.2458.2458,0,0,1,.2822.2138.25.25,0,0,1-.2139.2813l-6.2685.8584A.2761.2761,0,0,1,13.6528,96.5064Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.7876,98.6563a.2448.2448,0,0,1-.0459-.0044l-3.07-.5771a.2507.2507,0,0,1-.2-.292.246.246,0,0,1,.292-.1992l3.07.5771a.25.25,0,0,1-.0459.4956Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.0727,103.3844a.1235.1235,0,0,1-.1084-.0635L11.8725,99.62a.1246.1246,0,1,1,.2168-.123l2.0918,3.7011a.1245.1245,0,0,1-.0469.1705A.129.129,0,0,1,14.0727,103.3844Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8188,104.9283l-.0283-.0015a.25.25,0,0,1-.22-.2773l.57-4.9282a.2546.2546,0,0,1,.2763-.22.25.25,0,0,1,.22.2773l-.57,4.9282A.2492.2492,0,0,1,9.8188,104.9283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.8383,100.6349a.1249.1249,0,0,1-.0791-.2217l1.9746-1.626a.1249.1249,0,1,1,.1582.1934l-1.9746,1.6259A.1214.1214,0,0,1,6.8383,100.6349Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.3256,97.3121a.25.25,0,0,1-.0019-.5l5.6875-.05a.2533.2533,0,0,1,.2519.248.25.25,0,0,1-.248.252l-5.6875.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.2133,95.2a.2477.2477,0,0,1-.1338-.0391l-2.8164-1.79a.25.25,0,1,1,.2676-.4219l2.8164,1.79a.25.25,0,0,1-.1338.461Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0094,111.9757a5.2178,5.2178,0,0,1,0-10.4356,5.2178,5.2178,0,0,1,0,10.4356Zm0-9.9356a4.7178,4.7178,0,0,0,0,9.4356,4.7178,4.7178,0,0,0,0-9.4356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.0091,91.7252a5.2238,5.2238,0,0,1-5.2178-5.2178A5.2239,5.2239,0,0,1-1.0091,81.29a5.2239,5.2239,0,0,1,5.2177,5.2178A5.2238,5.2238,0,0,1-1.0091,91.7252Zm0-9.9356a4.723,4.723,0,0,0-4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178,4.7178,4.7229,4.7229,0,0,0,4.7177-4.7178A4.7229,4.7229,0,0,0-1.0091,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5729,91.3033a5.5469,5.5469,0,1,1,0-11.0937,5.5469,5.5469,0,1,1,0,11.0937Zm0-10.8437a5.2969,5.2969,0,1,0,0,10.5937,5.2969,5.2969,0,1,0,0-10.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.818,70.295a5.2027,5.2027,0,0,1,0-10.4053,5.2027,5.2027,0,1,1,0,10.4053Zm0-9.9053a4.7027,4.7027,0,0,0,0,9.4053,4.7027,4.7027,0,1,0,0-9.4053Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0045,43.3458a4.1264,4.1264,0,0,1-1.8369-.4336h0a4.1462,4.1462,0,0,1-1.8662-5.55A4.1433,4.1433,0,0,1,1.85,35.4962a4.1167,4.1167,0,0,1,2.083,2.3877,4.1122,4.1122,0,0,1-.2168,3.1616,4.1076,4.1076,0,0,1-2.3877,2.082A4.1447,4.1447,0,0,1,.0045,43.3458ZM-1.61,42.464a3.6238,3.6238,0,0,0,2.7793.19,3.6166,3.6166,0,0,0,2.1-1.8311,3.6122,3.6122,0,0,0,.1894-2.7793,3.6124,3.6124,0,0,0-1.831-2.0991,3.6422,3.6422,0,0,0-4.8789,1.6407A3.6457,3.6457,0,0,0-1.61,42.464Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: 106.1622,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0094,5.2232A5.224,5.224,0,0,1-4.2084.005,5.2239,5.2239,0,0,1,1.0094-5.2128,5.2238,5.2238,0,0,1,6.2272.005,5.2239,5.2239,0,0,1,1.0094,5.2232Zm0-9.936A4.7229,4.7229,0,0,0-3.7084.005,4.7233,4.7233,0,0,0,1.0094,4.7232,4.7233,4.7233,0,0,0,5.7272.005,4.7229,4.7229,0,0,0,1.0094-4.7128Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.5971,
    cy: 18.684,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 64.0924,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6887,
    cy: 39.204,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 86.5073,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0094,16.4478a.2486.2486,0,0,1-.2246-.1411L-1.72,13.1939a.249.249,0,0,1,.1162-.3339.25.25,0,0,1,.333.1162L.234,16.089a.2489.2489,0,0,1-.1162.3339A.2414.2414,0,0,1,.0094,16.4478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,5.2229A5.2238,5.2238,0,0,1,102.5442.0051a5.2178,5.2178,0,0,1,10.4356,0A5.2239,5.2239,0,0,1,107.762,5.2229Zm0-9.9355A4.7229,4.7229,0,0,0,103.0442.0051a4.7229,4.7229,0,0,0,4.7178,4.7178A4.723,4.723,0,0,0,112.48.0051,4.7229,4.7229,0,0,0,107.762-4.7126Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,5.2229A5.2238,5.2238,0,0,1,102.5444.0051a5.2178,5.2178,0,0,1,10.4355,0A5.2238,5.2238,0,0,1,107.7622,5.2229Zm0-9.9355A4.7229,4.7229,0,0,0,103.0444.0051a4.7229,4.7229,0,0,0,4.7178,4.7178A4.7229,4.7229,0,0,0,112.48.0051,4.7228,4.7228,0,0,0,107.7622-4.7126Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0471,
    cy: 0.5212,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0092,5.2229A5.2238,5.2238,0,0,1-4.2085.0051,5.2238,5.2238,0,0,1,1.0092-5.2126,5.2238,5.2238,0,0,1,6.227.0051,5.2238,5.2238,0,0,1,1.0092,5.2229Zm0-9.9355A4.7228,4.7228,0,0,0-3.7085.0051,4.7229,4.7229,0,0,0,1.0092,4.7229,4.7229,4.7229,0,0,0,5.727.0051,4.7229,4.7229,0,0,0,1.0092-4.7126Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: -0.5905,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,3.2332A4.2327,4.2327,0,0,1,18.53-.9949a4.2327,4.2327,0,0,1,4.2286-4.228,4.2325,4.2325,0,0,1,4.2275,4.228A4.2325,4.2325,0,0,1,22.7583,3.2332Zm0-8.2061A3.9832,3.9832,0,0,0,18.78-.9949a3.9832,3.9832,0,0,0,3.9786,3.9781A3.9823,3.9823,0,0,0,26.7358-.9949,3.9823,3.9823,0,0,0,22.7583-4.9729Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: -0.9948,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.53,4.8523a4.8276,4.8276,0,0,1-2.15-.5078h0A4.8123,4.8123,0,0,1,80.9418,1.55a4.8091,4.8091,0,0,1,.253-3.7,4.8523,4.8523,0,0,1,6.4941-2.1846,4.811,4.811,0,0,1,2.4365,2.7949A4.8074,4.8074,0,0,1,89.8725,2.16a4.81,4.81,0,0,1-2.7939,2.437A4.8442,4.8442,0,0,1,85.53,4.8523Zm.0118-9.1914a4.3514,4.3514,0,0,0-3.9,2.4121A4.318,4.318,0,0,0,81.4155,1.39,4.3139,4.3139,0,0,0,83.602,3.8963h0a4.31,4.31,0,0,0,3.3164.227,4.3176,4.3176,0,0,0,2.5068-2.186A4.3173,4.3173,0,0,0,89.6518-1.38,4.3156,4.3156,0,0,0,87.4663-3.886,4.3143,4.3143,0,0,0,85.5415-4.3391Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: -1.4679,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,5.0315a4.0264,4.0264,0,1,1,4.0264-4.0264A4.0312,4.0312,0,0,1,67.9321,5.0315Zm0-7.8027a3.7764,3.7764,0,1,0,3.7764,3.7763A3.7807,3.7807,0,0,0,67.9321-2.7712Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6772,
    cy: 0.0052,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0094,5.2229A5.2239,5.2239,0,0,1-4.2084.0051,5.2239,5.2239,0,0,1,1.0094-5.2126,5.2238,5.2238,0,0,1,6.2272.0051,5.2238,5.2238,0,0,1,1.0094,5.2229Zm0-9.9355A4.7229,4.7229,0,0,0-3.7084.0051,4.7229,4.7229,0,0,0,1.0094,4.7229,4.7229,4.7229,0,0,0,5.7272.0051,4.7229,4.7229,0,0,0,1.0094-4.7126Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6253,
    cy: -0.5905,
    r: 2.9027
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 63.7795,
    cy: 63.7795,
    r: 57.7278
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 63.7795,
    cy: 63.7795,
    r: 57.7278
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 63.7795,
    cy: 63.7795,
    r: 57.7278
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 63.7795,
    cy: 63.7795,
    r: 57.7278
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceC);
export default __webpack_public_path__ + "static/media/space-C.2061c77a4d7e42c7e3d75afcb30433a7.svg";
export { ForwardRef as ReactComponent };